import { render, staticRenderFns } from "./EventHistoryTenderChangeProps.vue?vue&type=template&id=824a529a&scoped=true"
import script from "./EventHistoryTenderChangeProps.vue?vue&type=script&lang=js"
export * from "./EventHistoryTenderChangeProps.vue?vue&type=script&lang=js"
import style0 from "./EventHistoryTenderChangeProps.vue?vue&type=style&index=0&id=824a529a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824a529a",
  null
  
)

export default component.exports